export const SET_STATE = 'produce-threshold-message-set-state'
export const UPDATE = 'produce-threshold-message-update'

export const formInitalState = {
  name: '',
  priority: 'medium',
  config: [],
  message: '',
  processing_method: 'single'
}

export const formReducer = (state, action) => {
  if (action.type === UPDATE) {
    return { ...state, [action.name]: action.value }
  } else if (action.type === SET_STATE) {
    return action.state
  }
  return state
}
